import random from 'lodash/random'

import { filterMessageOptions } from './constants'

/**
 * Loads appropriate loading screen message
 */
export const getLoadingScreenMessage = (isSliceSelection, sortOptions) => {
  if (isSliceSelection) {
    return 'Combining new flight options...'
  }

  if (sortOptions) {
    return 'Sorting flights...'
  }

  const randomOption = random(2)
  return filterMessageOptions[randomOption]
}
